<template>
  <div class="ui-search-bar" :class="isTop ? 'top' : ''">
    <div class="input-box">
      <i class="icon icon-search"></i>
      <form action onsubmit="return false;" autocomplete="“off”">
        <input
          type="search"
          placeholder="搜索作品名称、作者等关键信息"
          v-model="keyWord"
          id="searchBox"
          ref="searchBox"
          autocomplete="off"
          @search="handleSearch"
        />
      </form>
      <i class="icon icon-close" @click="handelClear" v-show="keyWord !== ''"></i>
    </div>
    <span class="btn btn-cancel" :disabled="keyWord === ''" @click="handleSearch">搜索</span>
  </div>
</template>

<script>
export default {
  name: "uiSearchbar",
  props: {
    isTop: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      keyWord: ""
    }
  },
  methods: {
    handelClear() {
      this.keyWord = ""
      this.$emit("refreshSearch", this.keyWord)
    },
    handleSearch() {
      if (this.keyWord !== "") {
        this.$emit("search", this.keyWord)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-search-bar {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0.35rem 0.3rem 0.4rem;
  width: 100%;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 0.3rem 0.3rem 0 0;
  transition: all 100ms ease-in-out;
  overflow: hidden;
  &.top {
    border-radius: 0;
  }
  .input-box {
    background: #eeeeee;
    border-radius: 0.35rem;
    padding: 0 0.2rem;
    display: flex;
    align-items: center;
    position: relative;
    height: 0.64rem;
    flex: 1;
    .icon-search {
      background: url("../../../../assets/images/searchbar_icon_grey.png") no-repeat center;
      background-size: 100%;
      height: 0.36rem;
      width: 0.36rem;
      margin-right: 0.1rem;
      flex: none;
    }
    form {
      height: 100%;
      flex: 1;
      display: flex;
    }
    input {
      height: 100%;
      border: none;
      outline: none;
      background: transparent;
      padding: 0.18rem 0;
      font-family: PingFangSC-Regular;
      font-size: 0.28rem;
      color: #333333;
      line-height: 0.28rem;
      flex: 1;
      line-height: 0.44rem;
    }
    .icon-close {
      background: url("../../../../assets/images/icon_close.png") no-repeat center;
      background-size: 0.2rem 0.2rem;
      height: 100%;
      width: 0.64rem;
      position: absolute;
      top: 0;
      right: 0;
      &:active {
        opacity: 0.7;
      }
    }
  }
  .btn-cancel {
    margin-left: 0.3rem;
    font-family: PingFangSC-Regular;
    font-size: 0.32rem;
    color: #333333;
    letter-spacing: 0;
    text-align: center;
    flex: none;
    color: #4ca1fe;
    &:active {
      opacity: 0.7;
    }
    &[disabled] {
      color: #999999;
      &:active {
        opacity: 1;
      }
    }
  }
}
</style>
